export const getPluralName = (translatedName: string, count?: number) => {
  if (!count || count <= 1) return translatedName;

  if (translatedName.endsWith("y")) {
    return translatedName.slice(0, -1) + "ies";
  } else if (
    translatedName.endsWith("s") ||
    translatedName.endsWith("sh") ||
    translatedName.endsWith("ch") ||
    translatedName.endsWith("x") ||
    translatedName.endsWith("z")
  ) {
    return translatedName + "es";
  } else {
    return translatedName + "s";
  }
};